import {gql, useQuery} from 'admin/lib/apollo'

export const QUERY = gql`
  query GetOrganisations {
    organisations {
      id
      internalName
      internalColor
    }
  }
`

export default () => {
  const {data: {organisations = []} = {}, error: getError} = useQuery(QUERY)

  return {
    organisations,
    errors: getError || {}
  }
}
